import { Link } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { Button } from "@ndd/ui";

/** The router's 404 page; a page that does not exist for its viewer renders it too. */
export function NotFound(): ReactElement {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6 text-center">
      <p className="text-sm font-medium uppercase tracking-wider text-muted-foreground">
        404
      </p>
      <h1 className="mt-2 text-3xl font-bold font-sans text-foreground">
        Page not found
      </h1>
      <p className="mt-3 text-sm text-muted-foreground">
        The page you&apos;re looking for doesn&apos;t exist or may have moved.
      </p>
      <Button asChild className="mt-6">
        <Link to="/rds">Back to RDs</Link>
      </Button>
    </div>
  );
}
